/* eslint-disable react/no-children-prop */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  InputLeftElement,
  InputProps,
  InputRightElement,
  Text
} from '@chakra-ui/react';
import { ReactNode, useState } from 'react';
import { AiFillEye, AiFillEyeInvisible } from 'react-icons/ai';

type FloatLabelInputProps = {
  name: string;
  label: string;
  error?: string;
  icon?: ReactNode;
  type?: string;
  placeholder?: string;
  register?: any;
} & InputProps;

export const FloatLabelInput = ({
  name,
  label,
  icon,
  error,
  type = 'text',
  placeholder = ' ',
  register,
  ...rest
}: FloatLabelInputProps) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <FormControl
      variant="floating"
      id={name}
      mt="1rem"
      isInvalid={error ? true : false}
    >
      <InputGroup>
        <InputLeftElement pointerEvents="none" children={icon} />
        <Input
          placeholder={placeholder}
          id={name}
          name={name}
          autoComplete={name}
          type={type === 'password' && showPassword ? 'text' : type}
          {...rest}
          {...register(name)}
        />
        <FormLabel>{label}</FormLabel>
        {type === 'password' && (
          <InputRightElement w="4.5rem">
            {showPassword ? (
              <AiFillEyeInvisible
                size="1.7rem"
                color="#CCCCCC"
                cursor="pointer"
                onClick={handleShowPassword}
              />
            ) : (
              <AiFillEye
                size="1.7rem"
                cursor="pointer"
                color="#CCCCCC"
                onClick={handleShowPassword}
              />
            )}
          </InputRightElement>
        )}
      </InputGroup>

      {error && (
        <Text fontSize=".9rem" color="red.400">
          {error}
        </Text>
      )}
    </FormControl>
  );
};
